import React, { createContext, useCallback, useContext, useMemo, useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Modal from 'components/shared/Modal';
import { UserContext } from 'components/UserGuard';
import { useWindowSize } from 'util/Window';
import { ACCESS_DIGITAL_WALLET_CARD_POPUP_HIDDEN_LABEL, getExpDate } from 'util/LocalStorage';


export const AccessDigitalWalletCardModal: React.FunctionComponent = () => {
  const [open, setOpen] = useState(false);
  const user = useContext(UserContext);
  const { isMobile } = useWindowSize();

  const openModal = useCallback(async () => {
    setOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    suppressModalPopup(user.nccerCardNumber)
    //I would like to set a cookie that'll hide this from opening for the learner after it's been closed. BC it's opened on params it should not matter for later sessions
    setOpen(false)
  }, [user]);
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  useEffect(() => {
    const params: URLSearchParams = new URLSearchParams(search);
    const DWCOptIn: string = params.get('DWCOptIn') || '';
    if(DWCOptIn != '' && !isSuppressedPopup(user.nccerCardNumber)){
      //DWCOptIn should be '' if not there. We want to check that it is there.
      openModal()
    }
  }, [])

  //need to figure out how to open this with identity server register trigger. Maybe cookies maybe params
  return (
    <ExternalAccountModalContext.Provider value={{ setLoading, closeModal }}>
      <Modal 
        loading={loading} 
        open={open} 
        title={"Access Your Mobile Credentials"} 
        subTitleText={''} 
        onClose={closeModal} 
        actions={
          <Box sx={{display:"flex", flexDirection: 'row', justifyContent: 'right', gap:2, width:1, pt:4}}>
            <Button color="secondary" variant="outlined" onClick={closeModal} fullWidth={isMobile}>
              Got It
            </Button>
          </Box>
        }
        >
        <DWCModalInfo/>
      </Modal>
    </ExternalAccountModalContext.Provider>
  );
}

interface ExternalAccountModalContext {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  closeModal: () => void;
}

const ExternalAccountModalContext = createContext<ExternalAccountModalContext>({
  setLoading: () => undefined,
  closeModal: () => undefined,
});

export const DWCModalInfo: React.FunctionComponent = () => {
  const { isMobile } = useWindowSize();
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'left' }}>
        <img src={isMobile? '/images/nccer/images/BuilderfaxMobile.png' : '/images/nccer/images/NccerBuilderfax.png'}  width="100%"/>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '10px', fontWeight: "bold" }}>
        Your NCCER Credentials are Now Digital
      </Box>
      
      <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
        We've sent a sign-in link to the email and mobile number associated with your account.
        Open the link on your phone to download the BuilderFax app and log in. 
      </Box>
      {isMobile && 
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px' }}>
          <Button sx={{ display: 'flex', width:'50%' }} href='https://apps.apple.com/us/app/builderfax-by-lumber/id6754037484'>
            <img width="100%" src="/images/nccer/images/AppleStore.png"/>
          </Button>
          <Button sx={{ display: 'flex', width:'50%' }} href='https://play.google.com/store/apps/details?id=com.lumberfi.builderfax'>
            <img width="100%" src="/images/nccer/images/GooglePlay.png"/>
          </Button>
        </Box>
      }
    </>
  )
}

function isSuppressedPopup(nccerCardNumber: string | undefined): boolean {
  const key = ACCESS_DIGITAL_WALLET_CARD_POPUP_HIDDEN_LABEL + nccerCardNumber;
  const value = localStorage.getItem(key);
  const expiry = value ? parseFloat(value) : 0;

  return Boolean(expiry) && expiry > Date.now();
}

// Suppress automatic wallet card popup on page load.
function suppressModalPopup(nccerCardNumber: string | undefined): void {
  const key = ACCESS_DIGITAL_WALLET_CARD_POPUP_HIDDEN_LABEL + nccerCardNumber;
  // Suppress popup for a month. It should not appear again afterwards
  const timestamp = getExpDate(30) 
  localStorage.setItem(key, String(timestamp));
}